
import { Component, Vue, Prop } from "vue-property-decorator";
import { ISigmaRing } from '@/interfaces/mlm';
import { dispatchGetSigmaRings, dispAuthFetch } from '@/store/mlm/actions';
import ProductCarousel from '@/components/Main/Rings/ProductCarousel.vue';
import ProductList from '@/components/Main/Rings/ProductList.vue';
import ProductInfo from '@/components/Main/Rings/ProductInfo.vue';
import ProductPurchase from '@/components/Main/Rings/ProductPurchase.vue';

@Component({
  components: {
    ProductCarousel,
    ProductList,
    ProductPurchase,
    ProductInfo
  }
})
export default class ProductDescription extends Vue {
  @Prop({ type: Number, required: true }) readonly productType!: number;

  public sigma_rings: ISigmaRing[] = [];
  public sigma_rings_size_kit: ISigmaRing[] = [];
  public sigma_rings_without_size_kit: ISigmaRing[] = [];

  selectedSizeId: number | null = null;
  public productPurchaseShow: boolean = false;
  public selectedRingProduct: ISigmaRing | null = null;

  public productImages: string[] = [
    'img/ring-webp/3.webp',
    'img/ring-webp/1.webp', 
    'img/ring-webp/4.webp',
    'img/ring-webp/6.webp',
    'img/ring-webp/8.webp',
    'img/ring-webp/9.webp',
    'img/ring-webp/10.webp',
    'img/ring-webp/11.webp',
    'img/ring-webp/12.webp',
    'img/ring-webp/13.webp',
    'img/ring-webp/14.webp',
  ];

  public productImagesSizeKit: string[] = [
    'img/ring-webp/pack/IMG_4516.webp',
    'img/ring-webp/pack/IMG_4520.webp',
    'img/ring-webp/pack/IMG_4523.webp',
    'img/ring-webp/pack/IMG_4525.webp',
    'img/ring-webp/pack/IMG_4526.webp',
    'img/ring-webp/pack/IMG_4530.webp',
  ];

  get isSizeKit() {
    return this.productType === 2;
  }
  
  get currentProductImages() {
    return this.isSizeKit ? this.productImagesSizeKit : this.productImages;
  }
  
  get currentSigmaRings() {
    return this.isSizeKit ? this.sigma_rings_size_kit : this.sigma_rings_without_size_kit;
  }

  get productTitle() {
    return this.isSizeKit ? 'Size Kit' : 'Sigma Ring';
  }

  get equipmentList() {
    return this.isSizeKit 
      ? [
          '8 ring templates for sizing'
        ]
      : [
          'Sigma Ring',
          'Wireless charging case',
          'Type-C charging cable',
          'User manual'
        ];
  }

  get presentationPdfPath() {
    return this.$root.$i18n.locale === 'ru' || this.$root.$i18n.locale === 'tuv'
      ? '/rings/Презентация Sigma Ring.pdf'
      : '/rings/Presentation Sigma Ring.pdf';
  }

  get sigmaRings() {
    return this.$store.getters.sigmaRings;
  }

  onSizeSelectedId(id: number): void {
    this.selectedSizeId = id;
    // Обновляем selectedRingProduct при изменении выбранного размера
    const foundRing = this.currentSigmaRings.find(ring => ring.id === id) || null;
    this.selectedRingProduct = foundRing;
    // console.log('Selected id:', id);
  }

  public openProductPurchase() {
   
    const foundRing = this.currentSigmaRings.find(ring => ring.id === this.selectedSizeId) || null;
    this.selectedRingProduct = foundRing;
    this.productPurchaseShow = true;
  }

  public closeProductPurchase() {
    // console.log('closeProductPurchase');
    this.productPurchaseShow = false;
    // Сбрасываем выбор на дефолтное значение после закрытия покупки
    const productListRef = this.$refs.productListRef as InstanceType<typeof ProductList>;
    if (productListRef) {
      productListRef.resetSelection();
    }
  }

  // public async loadSigmaRingsList() {
  //   const sigmaRingsResp = await dispAuthFetch(this.$store, {
  //     input: "/api/v1/mlm/sigma_rings/",
  //     init: {
  //       method: "GET",
  //     },
  //   });

  //   if (sigmaRingsResp.status === 200) {
  //     const sigmaRingsResponse = await sigmaRingsResp.json();
  //     return sigmaRingsResponse;
  //   } else {
  //     this.$toast.error("Failed to get sigma rings, please try again later", {
  //       message: "Failed to get sigma rings, please try again later",
  //       duration: 3000,
  //       position: "bottom",
  //     });
  //     return null;
  //   }
  // }

  public async mounted() {
    // console.log('ProductDescription: Starting to load sigma rings...');
    // Проверяем, есть ли данные в store (и это не пустой массив)
    const storeRings = this.sigmaRings;
    if (storeRings && storeRings.length > 0) {
      this.sigma_rings = storeRings;
    } else {
      // Если данных нет или массив пустой, загружаем через API
      this.sigma_rings = await dispatchGetSigmaRings(this.$store) || [];
    }
    // console.log('ProductDescription: Loaded sigma_rings:', this.sigma_rings);
    
    this.sigma_rings_size_kit = this.sigma_rings.filter(ring => 
      ring.name.toLowerCase().includes('size kit')
    );
    this.sigma_rings_without_size_kit = this.sigma_rings.filter(ring => 
      !ring.name.toLowerCase().includes('size kit')
    ); 
    this.sigma_rings_without_size_kit.sort((a, b) => a.bitrix_product_id - b.bitrix_product_id);
  }
}
